webpackJsonp([2],{

/***/ 1053:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmation_vue__ = __webpack_require__(821);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e39fa6ac_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmation_vue__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(15);
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirmation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e39fa6ac_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e39fa6ac_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_confirmation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApplicationResource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var ApplicationResource = /*#__PURE__*/function () {
  function ApplicationResource() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, ApplicationResource);
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(ApplicationResource, [{
    key: "myApplications",
    value: function myApplications() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/applications');
    }
  }, {
    key: "applicationTemplates",
    value: function applicationTemplates() {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/applications/templates');
    }
  }, {
    key: "applicationTemplate",
    value: function applicationTemplate(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/applications/templates/' + id);
    }
  }, {
    key: "getApplication",
    value: function getApplication(id) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/applications/' + id);
    }
  }, {
    key: "loadInputData",
    value: function loadInputData(templateId, inputId, subjectId) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/applications/templates/' + templateId + '/' + inputId + '?subject_id=' + subjectId);
    }
  }, {
    key: "writeApplication",
    value: function writeApplication(formData) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        url: '/api/applications',
        method: 'POST',
        data: formData,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        }
      });
    }
  }, {
    key: "confirmApplication",
    value: function confirmApplication(string) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post('api/confirmation', {
        string: string
      });
    }
  }, {
    key: "downloadPDF",
    value: function downloadPDF(correspondenceID) {
      var url = '/api/applications/download/' + correspondenceID;
      return __WEBPACK_IMPORTED_MODULE_2_axios___default()({
        url: url,
        method: 'GET',
        responseType: 'blob'
      });
    }
  }, {
    key: "getApplicationProgress",
    value: function getApplicationProgress(correspondenceID) {
      return __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('/api/applications/getApplicationProgress/' + correspondenceID);
    }
  }]);

  return ApplicationResource;
}();



/***/ }),

/***/ 821:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_applicationResource__ = __webpack_require__(736);
//
//
//
//
//

var applicationResource = new __WEBPACK_IMPORTED_MODULE_0__api_applicationResource__["a" /* default */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    applicationResource.confirmApplication(this.$route.params.theString).then(function (response) {
      if (response.data.status == 'ok') {
        _this.helpers.notifySuccessMessage('დადასტურებულია/Approved');
      } else {
        _this.helpers.notifyErrorMessage('შეცდომა!/Something Went Wrong!');
      }
    });
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.a2f79f26ca4a75d59255.js